import { DietPlanSection as DietPlanSectionComponent } from './DietPlanSection';
import { safeArray } from '../utils/dataTransformers';

/**
 * Diet Plan Section Wrapper Component
 * Adapts the DietPlanSection to work with the refactored structure
 */
export const DietPlanSectionWrapper = ({ formikProps, todayDate, patientPlanData }) => {
    const {
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting,
    } = formikProps;

    return (
        <DietPlanSectionComponent
            values={values}
            errors={errors}
            touched={touched}
            allDates={safeArray(patientPlanData?.allDates)}
            todayDate={todayDate}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            handleSubmit={handleSubmit}
            loading={isSubmitting}
            setError={() => { }} // Error handling is done at parent level
        />
    );
};
